<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="orderLineDetails">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="orderLineDetails"
            [columnAutoWidth]="false"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="orderLine.order.invoiceNumber" caption="Order #" width="80" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
            <dxi-column dataField="orderLine.partNumberWithPrice" caption="Part #" width="200"></dxi-column>
            <dxi-column dataField="optionHTML" caption="Options" width="550" [encodeHtml]="false"></dxi-column>
            <dxi-column dataField="totalPrice" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="status.name" caption="Status" width="150"></dxi-column>
            <dxi-column dataField="invoice.invoiceNumber" caption="Invoice #" width="150" cellTemplate="invoiceTemplate"></dxi-column>
            <dxi-column dataField="hasInvoice" width="150"></dxi-column>
            <dxi-column dataField="hasInvoiceInQB" caption="InQB" width="150"></dxi-column>
            <dxi-column dataField="dueDate" width="150"></dxi-column>
            <dxi-column dataField="invoice.quickBooksId" caption="Invoice QB#" width="150"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-summary>
                <dxi-total-item column="totalPrice" summaryType="sum" valueFormat="currency"> </dxi-total-item>
            </dxo-summary>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="report-open-orders-grid"></dxo-state-storing>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="open(cell.data.orderLine.orderId)">{{ cell.value || '(blank)' }}</a>
            </div>
            <div *dxTemplate="let cell of 'invoiceTemplate'">
                <a [routerLink]="[]" (click)="openInvoice(cell.data.invoiceId)">{{ cell.value }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderLineDetails" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
